/**
 * AmbientBackground (Neo-Brutalist Version)
 *
 * Simple background with:
 * - Warm cream base color
 * - Subtle dot grid pattern
 * No blur effects or floating gradients
 */
export function AmbientBackground() {
  return (
    <div
      className="fixed inset-0 -z-10 bg-[#FFFBF0]"
      aria-hidden="true"
    >
      {/* Subtle dot grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "radial-gradient(#000000 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
    </div>
  );
}
